import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const ChevronArrowRightIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 11 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M0.153479 19.1463C-0.0510226 19.3414 -0.0511795 19.658 0.153128 19.8534C0.357436 20.0487 0.688841 20.0489 0.893343 19.8537L10.8465 10.3547C11.0511 10.1594 11.0512 9.84262 10.8466 9.64732L0.893382 0.146316C0.688902 -0.0488738 0.357497 -0.0487572 0.153167 0.146577C-0.0511621 0.341911 -0.0510401 0.658493 0.15344 0.853684L9.73606 10.001L0.153479 19.1463Z' />
    </svg>
  );
};
